module.exports = __webpack_public_path__ + "static/media/July_2026_4.afb480a9.webp";